<template>
  <div>
    <vx-card class="mt-3">
          <vs-table
      :sst="true"
      @search="handleSearch"
      @change-page="handleChangePage"
      v-model="selected"
      @sort="handleSort"
      pagination
      max-items="10"
      search
      :data="mids"
    >
      <template slot="header">
        
        <vs-button
          style="margin-left:5px;margin-top:5px"
          icon-pack="feather"
          icon="icon-plus"
          
          @click="popupAdd=true"
        >Add MID</vs-button>
      </template>
      <template slot="thead">
        <vs-th sort-key="id">No.</vs-th>
        <vs-th sort-key="code">Code</vs-th>
        <vs-th sort-key="name">Name</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
          <vs-td :data="data[indextr].id">{{ indextr +1 }}</vs-td>
          <vs-td :data="data[indextr].code">{{ data[indextr].code }}</vs-td>
          <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-button @click="deleteMid()" v-if="selected!=''" color="danger" class="m-3" >Delete</vs-button>
    <vs-button @click="editMid(),popupEdit=true" v-if="selected!=''" color="warning" class="m-3" >Edit</vs-button>

    </vx-card>

    <div class="demo-alignment">
    <vs-popup :active.sync="popupAdd" classContent="popup-example" title="New Mid" >
      <vs-input v-model="theMids.code" class="w-full mb-3" placeholder="code" />
      <vs-input v-model="theMids.name" class="w-full mb-3" placeholder="name" />
      <vs-button @click="insertMid()" color="primary" class="w-full" type="filled">Save</vs-button>
    </vs-popup>
    </div>

    <div class="demo-alignment">
    <vs-popup :active.sync="popupEdit" classContent="popup-example" title="Edit Mid" >
      <vs-input v-model="editMids.code" class="w-full mb-3" placeholder="code" />
      <vs-input v-model="editMids.name" class="w-full mb-3" placeholder="name" />
      <vs-button color="primary" class="w-full" type="filled">Update</vs-button>
    </vs-popup>
    </div>

  </div>
</template>
<script>
import axios from "axios";
import { API_BASE_URL } from '@/constants'

export default {
  data() {
    return {
      selected: [],
      mids: this.$store.state.mids,
      popupAdd:false,
      popupEdit:false,
      theMids: {
        code: "",
        name: ""
      },
      editMids: {
        code: "",
        name: ""
      }
    };
  },
  mounted() {
    this.$store.dispatch("updateTitlePage","Setting/MID")
  },
  methods: {
    insertMid(){
      axios
       .post(`${API_BASE_URL}/admin/mids.json`
       ,this.theMids
       ,{
         headers: {
           "X-User-Email": "api@excise-online.com",
           "X-User-Token": "m2Nc1hmx7s97eCA1FMYA"
         }
       })
       .then(response => {
            this.mids.unshift(response.data)
            this.popupAdd=false
       })
       .catch(error => {
         this.popupAdd=true
       });
    },
    editMid(){
      this.editMids = this.selected
    },
    updateMid(){
      axios
       .put(`${API_BASE_URL}/admin/mids/${this.selected.id}.json`
       ,this.editMids
       ,{
         headers: {
           "X-User-Email": "api@excise-online.com",
           "X-User-Token": "m2Nc1hmx7s97eCA1FMYA"
         }
       })
       .then(response => {
         let indexOfmids = this.mids.indexOf(this.selected)
         this.mids.splice(indexOfmids, 1,this.editMids);
         this.popupEdit=false
       });
    },
    deleteMid(){
      axios
       .delete(`${API_BASE_URL}/admin/mids/${this.selected.id}.json`
       ,{
         headers: {
           "X-User-Email": "api@excise-online.com",
           "X-User-Token": "m2Nc1hmx7s97eCA1FMYA"
         }
       })
       .then(response => {
         let indexOfmids = this.mids.indexOf(this.selected)
         this.mids.splice(indexOfmids, 1);
       })
       .catch(error => {
         console.log("no-delete")
       });
    },
    handleSearch(searching) {
      let _print = `The user searched for: ${searching}\n`
      this.$refs.pre.appendChild(document.createTextNode(_print))
    },
    handleChangePage(page) {
      let _print = `The user changed the page to: ${page}\n`
      this.$refs.pre.appendChild(document.createTextNode(_print))
    },
    handleSort(key, active) {
      let _print = `the user ordered: ${key} ${active}\n`
      this.$refs.pre.appendChild(document.createTextNode(_print))
    }
  }
};
</script>